export default __webpack_public_path__ + "static/media/calendar.c2893221.svg";